import { render } from "./HomeTennis.vue?vue&type=template&id=3a7c9943&ts=true"
import script from "./HomeTennis.vue?vue&type=script&lang=ts"
export * from "./HomeTennis.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__